const FULL_CARD_DETAILS = `
  id
  createdAt
  subscriptionStart
  subscriptionEnd
  lastUsed
  lastUsedLocation
  iccid
  imei
  imsi
  pin1
  puk1
  pin2
  puk2
  pk
  msisdn
  status
  currentPricePlan {
      code
      name
  }
  minutesLeft
  minutesUsed
  validUntil
`;

const LIST_CARD_DETAILS = `
 {
  createdAt
  iccid
  imei
  imsi
  pk
  msisdn
  status
  currentPricePlan {
      name
  }
  minutesLeft
  minutesUsed
  validUntil
}
`;

export const CARD_BY_ICCID = `
query cardByIccid($iccid: String!) {
  cardByIccid(iccid: $iccid) {
    __typename
    ... on Card {
      ${FULL_CARD_DETAILS}
    }
    ... on Cdr {
      originCountry
      originNumber
      cdrTimestamp
      product
      service
      destNumber
      destNetwork
      destCountry
      volumeTotalMin
      volumeTotalData
      volumeTotalMsg
      cdrTotal
      cdrCurrency
    }
  }
}
`;

export const CARDS_BY_ICCID = `
query cardsByIccid($iccid: String!) {
  cardsByIccid(iccid: $iccid) {
    __typename
    activated
      ${LIST_CARD_DETAILS}
    archived
      ${LIST_CARD_DETAILS}
    dormant
      ${LIST_CARD_DETAILS}
    tobeVerified
      ${LIST_CARD_DETAILS}
  }
}
`;

export const CARDS_BY_USER = `
query cardsByUser($userId: ID!) {
    cardsByUser(userId: $userId) {
        __typename
    activated
      ${LIST_CARD_DETAILS}
    archived
      ${LIST_CARD_DETAILS}
    dormant
      ${LIST_CARD_DETAILS}
    tobeVerified
      ${LIST_CARD_DETAILS}
    }
}
`
